import { Circle, ListItem } from "arkh";
import React, { PropsWithChildren } from "react";
import { ActivityIndicator } from "react-native";

export function IntegrationAdminListItem(
  props: PropsWithChildren<
    {
      isFirst: boolean;
      isLast: boolean;
      onPress?(): void;
      disabled?: boolean;
    } & (
      | {
          active: boolean;
          pending?: boolean;
          status?: never;
        }
      | {
          status: "positive" | "semiNegative" | "negative" | "loading";
        }
    )
  >
) {
  return (
    <ListItem
      border="border-primary"
      isFirst={props.isFirst}
      isLast={props.isLast}
      onPress={props.onPress}
      disabled={props.disabled}
      right={
        props.status === "loading" ? (
          <ActivityIndicator size="small" color="#000" />
        ) : (
          <Circle
            size="badge"
            color={
              props.status
                ? `status-${props.status}`
                : props.pending
                  ? "washedText"
                  : props.active
                    ? "positive"
                    : "negative"
            }
          />
        )
      }
    >
      {props.children}
    </ListItem>
  );
}
